import type { ProjectId } from 'owa-timestream-types';
import getProject from './getProject';

export default function getAssets(projectId: ProjectId) {
    return projectId ? [...getProject(projectId).assets.entries()] : [];
}
